@if ({
  specializations: subscriptionSpecializations$ | async,
  locations: subscriptionLocations$ | async,
  seniorityLevels: subscribedSeniorityLevels$ | async
}; as data) {
  <div class="page">
    <div class="page__inner">
      <section class="subscription">
        <h1 class="subscription__title">{{ 'label.EditSubscription' | translate }}</h1>

        <div class="subscription__rows">
          <ng-container
            *ngTemplateOutlet="row; context: { label: 'label.Specialties', items: data.specializations }"
          ></ng-container>
          <ng-container
            *ngTemplateOutlet="row; context: { label: 'label.Cities', items: data.locations }"
          ></ng-container>
          <ng-container
            *ngTemplateOutlet="row; context: { label: 'label.SeniorityLevel', items: data.seniorityLevels }"
          ></ng-container>
        </div>

        <div class="subscription__actions">
          <button type="button" class="subscription__button subscription__button--edit" (click)="onEdit()">
            {{ 'label.Edit' | translate }}
          </button>
          @if (data.specializations?.length || data.locations?.length || data.seniorityLevels?.length) {
            <button type="button" class="subscription__button subscription__button--cancel" (click)="onUnsubscribe()">
              {{ 'label.CancelSubscription' | translate }}
            </button>
          }
        </div>
      </section>
    </div>
  </div>
}

<ng-template #row let-label="label" let-items="items">
  <div class="subscription-row">
    <div class="subscription-row__label">{{ label | translate }}:</div>
    @if (items?.length) {
      <div class="subscription-row__value">
        @for (item of items; track item.id; let last = $last) {
          {{ item.name }}{{ last ? '' : ', ' }}
        }
      </div>
    }
  </div>
</ng-template>
